import { render, staticRenderFns } from "./TelegramLoginWidget.vue?vue&type=template&id=53e8c63c&scoped=true&lang=pug&"
import script from "./TelegramLoginWidget.vue?vue&type=script&lang=js&"
export * from "./TelegramLoginWidget.vue?vue&type=script&lang=js&"
import style0 from "./TelegramLoginWidget.vue?vue&type=style&index=0&id=53e8c63c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e8c63c",
  null
  
)

export default component.exports